import React from 'react';

import BaseAgGridTable from 'Components/AgGrid/BaseAgGridTable';
import { setGreenLight } from 'Helpers/FlightTicketHelper';
import { DS_F2W_HR_Team } from 'Constants/F2wRolesConstants';
import {
  firstName,
  lastName,
  destination,
  country,
  iataCode,
  season,
  staffSourceMarket,
  plannedAssignmentStartDate,
  greenLightUpdated,
} from 'Components/AgGrid/commonColumnDefs';

const GreenLightActionCell = ({ data, gridRef, datasourceFactory, dispatch }) => {
  return (
    <button
      className="btn btn-success btn-sm"
      style={{ margin: '0 5px', padding: '0.5% 1%', borderRadius: '5px', cursor: 'pointer', fontSize: '0.8rem' }}
      onClick={() => setGreenLight(data.id, gridRef, datasourceFactory, dispatch)}
    >
      Confirm
    </button>
  );
};

const greenLightAction = (gridRef, datasourceFactory, dispatch) => ({
  headerName: 'GreenLight',
  cellRenderer: (params) => {
    return (
      <GreenLightActionCell
        data={params.data}
        gridRef={gridRef}
        datasourceFactory={datasourceFactory}
        dispatch={dispatch}
      />
    );
  },
});

const getColumns = (gridRef, datasourceFactory, dispatch) => [
  firstName(),
  lastName(),
  destination(),
  country(),
  iataCode(),
  season(),
  staffSourceMarket(),
  plannedAssignmentStartDate(),
  greenLightUpdated('Request date HR'),
  greenLightAction(gridRef, datasourceFactory, dispatch),
];

const StatusPendingHrAgGridTable = () => (
  <BaseAgGridTable
    endpoint="staff/agGridTable/pendinghr"
    viewName="StatusPendingHr"
    statusPath="pendinghr"
    columns={getColumns}
    roleToCheckForActions={DS_F2W_HR_Team}
  />
);

export default StatusPendingHrAgGridTable;
